<template>
  <div class="stat-card-white" ref="captureArea">
    <div class="stat-header-white">
      <span>{{ chartlabel }}</span>
      <div v-show="!loader" class="d-flex align-items-center justify-content-end" v-if="!loader">
        <select v-if="showcatoptions" class="graph-select py-0" v-model="selectedxaxis" id="fieldSelect">
          <option value="" disabled>Select X-Axis Field</option>
          <option v-for="(column, index) in attributeOptions" :key="index" :value="column">
            {{ column }}
          </option>
        </select>

        <select v-if="categoryfield != ''" class="graph-select py-0 col-md-4" id="categorySelect" v-model="selectedCategory">
          <option value="">Select All</option>
          <option v-for="(category, index) in uniqueCategories" :key="index" :value="category">
            {{ category }}
          </option>
        </select>

        <div v-if="!loader" class="expand-block px-2 mb-1 cursor-pointer position-relative">
          <img class="cursor-pointer" @click="showtable()" src="../../assets//img/table_view.png" alt="More block">
          <div class="more-expand">
            <span>{{$t("navigations.data overview")}}</span>
          </div>
        </div>

        <div class="expand-block px-2 mb-1 cursor-pointer" @click.prevent="expandBlock=true">
          <img src="../../assets//img/expand.png" alt="Expand block">
        </div>

        <div class="text-center" v-on:clickout="showVisitPopup = false">
          <div class="position-relative cursor-pointer biggerfont ml-2" @click.prevent="showVisitPopup = !showVisitPopup">
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="plan-side-popup" ref="excludeThis" v-if="showVisitPopup">
            <div @click.prevent="showVisitPopup = false,exporttoexcell()">
              Export to Excel
            </div>
            <div @click.prevent="exporttopdf()">
              Export to PDF
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stat-body-white d-flex flex-column" :class="{'h-100':loader==true}">
      <div v-if="loader" class="loader"></div>

      <div v-if="!loader && selectedGroups.length!=0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
        <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelSelection()" alt="Save profile"/>
        <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreateChart()" alt="Save profile"/>
      </div>
    <div v-if="colorcodes.length!=0 && !loader" class="d-flex gap-3">
      <div v-for="colors in colorcodes" :key="colors.type" class="mx-auto d-flex">
        <div class="legandbox" :style="`background-color: ${colors.color};`"></div>
        {{ colors.type }}
      </div>
    </div>
      <div ref="chartContainerWidth" :class="{'overflow-x-auto':fromPage=='statusReport'}" v-show="!loader" class="w-100 overflow-auto">
        <svg ref="chartContainer"></svg>
        <div ref="tooltip" class="tooltip"></div>
      </div>
    </div>

    <enlargerpopup v-if="expandBlock==true" @closeModal="expandBlock=false,createBarChart()">
      <div class="stat-body-white d-flex flex-column">
        <div v-if="!loader && selectedGroups.length!=0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
          <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelSelection()" alt="Save profile"/>
          <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreateChart()" alt="Save profile"/>
        </div>
        <div class="histogram-content overflow-x-scroll">
          <svg ref="popupChartContainer"></svg>
        </div>
      </div>
     
    </enlargerpopup>
  </div>
</template>

<script>
import * as d3 from 'd3';
import enlargerpopup from "../AiCharts/popupfiles/enlarge_popup.vue";
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js';

export default {
  name: 'BarChart',
  components:{ enlargerpopup },
  props: {
    data: { type: Array, required: true, default: () => [] },
    availableColumns: { type: Array, required: true, default: () => [] },
    loader: { type: Boolean, default: false },
    barlabelvertical: { type: Boolean, default: false },
    xAxisKey: { type: String, default: 'AEOUT' },
    valuecalculation: { type: String, default: 'average' }, // 'average' or default modes
    yAxisKey: { type: String, default: 'AEYN' },
    yAxisLabel: { type: String, default: 'Count' },
    xAxisLabel: { type: String, default: '' },
    chartlabel: { type: String, default: "Bar chart" },
    categoryfield:{ type: String, default: "" },
    colorkey: { type: String, default: "" },
    fromPage:{ type:String, default:"" },
    graphwidth: { type: Number, default: 1200 },
    width: { type: Number, default: 800 },
    graphheight: { type: Number, default: 400 },
    showcatoptions: { type: Boolean, default: true },
    drilldowneabled: { type: Boolean, default: true },
    sort: { type: String, default: "" }, // 'increasing' | 'decreasing' | ''
  },
  data() {
    return {
      showVisitPopup: false,
      attributeOptions: [],
      selectedxaxis: "",
      chartdata: [],
      graphdata: [],
      selectedyaxis: "",
      chartContainer: null,
      resizeObserver: null,
      tooltip: null,
      expandBlock: false,
      barselectedarray: [],
      sortdata: [],
      filterkeyword: "",
      filterarray: [],
      selectedGroups: [],
      color: {},
      tableArray: [],
      mouseX: 0,
      mouseY: 0,
      selectedCategory: "",
      uniqueCategories: [],
      colorcodes: [
      { type: "Low", color: "#87d37c" },    // green
      { type: "Medium", color: "#f5d76e" },  // yellow
      // { type: "21-30", color: "#cccccc" },  // default/gray
      { type: "High", color: "#f22613" }     // red
    ]
    };
  },
  mounted() {
    this.extractAttributeOptions();
    window.addEventListener('mousemove', this.updateMousePosition);
    this.selectedxaxis = this.xAxisKey;
    this.selectedyaxis = this.yAxisKey;
    this.chartContainer = this.$refs.chartContainer;
    this.tooltip = this.$refs.tooltip;
    this.updateUniqueCategories();
    this.createBarChart();
    this.resizeObserver = new ResizeObserver(() => this.createBarChart());
    if (this.$refs.chartContainer) this.resizeObserver.observe(this.$refs.chartContainer);
  },
  watch: {
    data: {
      handler() {
        this.graphdata = this.data;
        this.extractAttributeOptions();
        this.updateUniqueCategories();
        this.createBarChart();
        this.cancelSelection();
      },
      deep: true,
    },
    selectedxaxis() {
      this.createBarChart();
      this.cancelSelection();
    },
    selectedyaxis() {
      this.createBarChart();
    },
    selectedCategory() {
      this.createBarChart();
    },
    expandBlock(newValue) {
      if (newValue) {
        this.$nextTick(() => this.createBarChart());
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('mousemove', this.updateMousePosition);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    async exporttoexcell() {
      this.$emit("exporttoexcell");
    },
    exporttopdf() {
      const excludeElement = this.$refs.excludeThis;
      if (excludeElement) excludeElement.style.display = 'none';
      const pdfContainer = document.createElement('div');
      const captureArea = this.$refs.captureArea.cloneNode(true);
      pdfContainer.appendChild(captureArea);
      pdfContainer.style.width = '100%';
      pdfContainer.style.display = 'block';
      const opt = {
        margin: 0,
        filename: `${this.chartlabel}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
      };
      html2pdf().set(opt).from(pdfContainer).save();
      if (excludeElement) setTimeout(() => (excludeElement.style.display = ''), 0);
    },

    extractAttributeOptions() {
      if (this.data.length > 0) {
        if (this.availableColumns.length === 0) {
          this.attributeOptions = Object.keys(this.data[0]).filter((key) =>
            key !== '_id' && key !== 'STUDYID' && key !== 'USUBJID'
          );
        } else {
          this.attributeOptions = this.availableColumns;
        }
      }
    },

    updateUniqueCategories() {
      if (this.categoryfield && this.data.length > 0) {
        this.uniqueCategories = [...new Set(
          this.data
            .map(item => item[this.categoryfield])
            .filter(v => v !== null && v !== undefined && String(v).trim() !== '')
        )].sort();
      } else {
        this.uniqueCategories = [];
      }
    },

    updateMousePosition(event) {
      if (!this.$refs.chartContainer || !this.$refs.chartContainer.getBoundingClientRect) return;
      const rect = this.$refs.chartContainer.getBoundingClientRect();
      this.mouseX = event.clientX - rect.left;
      this.mouseY = event.clientY - rect.top;
    },

    showtable() {
      this.$emit("opendrillpopup", this.chartdata);
    },

    async cancelSelection() {
      this.selectedGroups = [];
      this.sortdata = [];
      this.createBarChart();
    },

    backtooriginal() {
      this.sortdata = [];
      this.selectedGroups = [];
    },

    // ---------- GROUPING (excludes null/empty x-values) ----------
    computeGroupedData(filteredData) {
      const xKey = this.selectedxaxis;
      const yKey = this.selectedyaxis;

      // filteredData already excludes null/empty x-values

      if (this.valuecalculation === 'average') {
        return d3.rollups(
          filteredData,
          v => {
            const nums = v
              .map(d => parseFloat(d[yKey]))
              .filter(n => Number.isFinite(n));
            return nums.length ? d3.sum(nums) / nums.length : 0;
          },
          d => d[xKey]
        );
      }

      if (yKey === 'AEYN') {
        return d3.rollups(
          filteredData,
          v => v.filter(d => d[yKey] === 'Yes').length,
          d => d[xKey]
        );
      } else if (yKey === 'count') {
        return d3.rollups(
          filteredData,
          v => v.length,
          d => d[xKey]
        );
      } else {
        const fd = filteredData.filter(d => d[yKey] !== 0 && d[yKey] !== "0");
        return d3.rollups(
          fd,
          v => d3.sum(v, d => +d[yKey]),
          d => d[xKey]
        );
      }
    },

    getThresholdColor(val) {
      if (this.valuecalculation !== 'average') return null;
      if (val >= 0 && val < 10) return '#87d37c';   // green
      if (val >= 10 && val <= 20) return '#f5d76e'; // yellow
      if (val > 30) return '#f22613';               // red
      return null;                                   // default palette for 20–30
    },

    formatBarLabel(val) {
      return Number.isInteger(val) ? String(val) : (+val).toFixed(2).replace(/\.00$/, '');
    },

    createBarChart() {
      this.chartContainer = this.expandBlock ? this.$refs.popupChartContainer : this.$refs.chartContainer;
      this.chartdata = this.data;
      if (!this.chartContainer) return;

      d3.select(this.chartContainer).selectAll('*').remove();

      // Filter data: DROP rows where x-axis is null/undefined/empty/whitespace
      let filteredData = this.data.filter(d => {
        const v = d[this.selectedxaxis];
        return v !== null && v !== undefined && String(v).trim() !== '';
      });

      // Optional category filter
      if (this.selectedCategory && this.categoryfield) {
        filteredData = filteredData.filter(d => d[this.categoryfield] === this.selectedCategory);
      }

      if (this.fromPage === 'statusReport') {
        // ==== STATUS REPORT LAYOUT ====
        const margin = { top: 30, right: 20, bottom: 100, left: 70 };
        const fixedBarWidth = 40;
        const gapBetweenBars = 10;

        // Grouped/aggregated values
        let groupedData = this.computeGroupedData(filteredData);

        // Width based on group count
        const dataCount = groupedData.length;
        const totalBarsWidth = Math.max(0, (dataCount * fixedBarWidth) + Math.max(0, (dataCount - 1) * gapBetweenBars));
        const svgWidth = totalBarsWidth + margin.left + margin.right;
        const height = this.graphheight - margin.top - margin.bottom;

        const svg = d3
          .select(this.chartContainer)
          .attr('width', svgWidth)
          .attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr('transform', `translate(${margin.left},${margin.top})`);

        // Color palette/domain maintenance
        if (this.colorkey && this.colorkey !== '') {
          this.color = d => d[this.colorkey] || '#62B2FD';
        } else {
          if (!this.color || typeof this.color.domain !== 'function') {
            this.color = d3.scaleOrdinal()
              .range(['#62B2FD', '#9BDFC4', '#ABF0FF', '#C1D1FF', '#FBD164', '#FDAD73'].concat(d3.schemeCategory10));
          }
          const currentDomain = this.color.domain();
          const newKeys = groupedData.map(d => d[0]);
          const updatedDomain = [...currentDomain, ...newKeys.filter(key => !currentDomain.includes(key))];
          this.color.domain(updatedDomain);
        }

        const x = d3.scaleBand()
          .domain(groupedData.map(d => d[0]))
          .range([0, totalBarsWidth])
          .padding(0.2);

        svg
          .append('g')
          .attr('transform', `translate(0,${height})`)
          .call(d3.axisBottom(x))
          .selectAll('text')
          .text(d => {
            const label = d;
            return String(label).length > 13 ? `${String(label).slice(0, 10)}...` : label;
          })
          .attr('transform', 'translate(-10,0)rotate(-45)')
          .style('text-anchor', 'end');

        const y = d3.scaleLinear()
          .domain([0, d3.max(groupedData, d => d[1]) || 0])
          .nice()
          .range([height, 0]);

        svg.append('g').call(d3.axisLeft(y));

        svg.append('text')
          .attr('transform', 'rotate(-90)')
          .attr('y', 0 - margin.left)
          .attr('x', 0 - (height / 2))
          .attr('dy', '1em')
          .style('text-anchor', 'middle')
          .attr("font-size", "13px")
          .text(this.yAxisLabel);

        // Bars
        svg.selectAll('rect')
          .data(groupedData)
          .enter()
          .append('rect')
          .attr('x', d => x(d[0]) || 0)
          .attr('y', d => y(d[1]))
          .attr('width', x.bandwidth())
          .attr('height', d => height - y(d[1]))
          .attr('fill', d => {
            if (this.valuecalculation === 'average') {
              const t = this.getThresholdColor(d[1]);
              if (t) return t;
            }
            if (this.colorkey && this.colorkey !== '') {
              const item = filteredData.find(item => item[this.selectedxaxis] === d[0]);
              return item ? (item[this.colorkey] || '#62B2FD') : '#62B2FD';
            }
            return this.color(d[0]);
          })
          .attr("stroke", "none")
          .attr("style", d =>
            this.selectedGroups.length !== 0 ? (this.selectedGroups.includes(d[0]) ? "" : "opacity: 35%;") : ""
          )
          .on('mouseover', (event, d) => {
            d3.select(this.tooltip)
              .style('opacity', 1)
              .html(`Category: ${d[0]}<br>Value: ${this.formatBarLabel(d[1])}`)
              .style("left", this.mouseX + "px")
              .style("top", this.mouseY + "px");
          })
          .on("mouseout", () => d3.select(this.tooltip).style("opacity", 0))
          .on('mousemove', () => {
            d3.select(this.tooltip).style("left", this.mouseX + "px").style("top", this.mouseY + "px");
          })
          .on('click', (event, d) => {
            if (this.drilldowneabled) {
              d3.select(this.tooltip).style("opacity", 0);
              const filteredDataClick = this.data.filter(item => {
                const v = item[this.selectedxaxis];
                return v !== null && v !== undefined && String(v).trim() !== '' && v === d[0];
              });
              this.clickbarinchart(filteredDataClick, d[0]);
            }
          });

        // Value labels
        svg.selectAll('text.bar-label')
          .data(groupedData)
          .enter()
          .append('text')
          .attr('class', 'bar-label')
          .attr('text-anchor', 'middle')
          .text(d => this.formatBarLabel(d[1]))
          .each((d, i, nodes) => {
            const text = d3.select(nodes[i]);
            const barHeight = height - y(d[1]);
            const xPos = (x(d[0]) || 0) + x.bandwidth() / 2;
            if (this.barlabelvertical) {
              const yPos = y(d[1]) + barHeight / 2;
              text.attr('x', xPos).attr('y', yPos).attr('fill', 'black').attr('transform', `rotate(-90,${xPos},${yPos})`);
            } else {
              text.attr('x', xPos).attr('y', y(d[1]) - 5);
            }
          });

      } else {
        // ==== DEFAULT LAYOUT ====
        const margin = { top: 30, right: 300, bottom: 70, left: 60 };
        const width = this.width - margin.left - margin.right;
        const height = 400 - margin.top - margin.bottom;

        let groupedData = this.computeGroupedData(filteredData);

        if (this.sort === 'increasing') {
          groupedData.sort((a, b) => d3.ascending(a[1], b[1]));
        } else if (this.sort === 'decreasing') {
          groupedData.sort((a, b) => d3.descending(a[1], b[1]));
        }

        const svg = d3
          .select(this.chartContainer)
          .attr('width', width + margin.left + margin.right)
          .attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr('transform', `translate(${margin.left},${margin.top})`);

        if (this.colorkey && this.colorkey !== '') {
          this.color = d => d[this.colorkey] || '#62B2FD';
        } else {
          if (!this.color || typeof this.color.domain !== 'function') {
            this.color = d3.scaleOrdinal()
              .range(['#62B2FD', '#9BDFC4', '#ABF0FF', '#C1D1FF', '#FBD164', '#FDAD73'].concat(d3.schemeCategory10));
          }
          const currentDomain = this.color.domain();
          const newKeys = groupedData.map(d => d[0]);
          const updatedDomain = [...currentDomain, ...newKeys.filter(key => !currentDomain.includes(key))];
          this.color.domain(updatedDomain);
        }

        const x = d3.scaleBand()
          .domain(groupedData.map(d => d[0]))
          .range([0, width])
          .padding(0.2);

        svg
          .append('g')
          .attr('transform', `translate(0,${height})`)
          .call(d3.axisBottom(x))
          .selectAll('text')
          .text(d => {
            const label = d;
            return String(label).length > 6 ? `${String(label).slice(0, 10)}...` : label;
          })
          .attr('transform', 'translate(-10,0)rotate(-45)')
          .style('text-anchor', 'end');

        const y = d3.scaleLinear()
          .domain([0, d3.max(groupedData, d => d[1]) || 0])
          .nice()
          .range([height, 0]);

        svg.append('g').call(d3.axisLeft(y));

        svg.append('text')
          .attr('transform', 'rotate(-90)')
          .attr('y', 0 - margin.left)
          .attr('x', 0 - (height / 2))
          .attr('dy', '1em')
          .style('text-anchor', 'middle')
          .attr("font-size", "13px")
          .text(this.yAxisLabel);

        svg.append("text")
          .attr("x", width / 2)
          .attr("y", height + margin.bottom - 20)
          .attr("text-anchor", "middle")
          .attr("font-size", "13px")
          .text(this.xAxisLabel);

        svg.selectAll('rect')
          .data(groupedData)
          .enter()
          .append('rect')
          .attr('x', d => x(d[0]) || 0)
          .attr('y', d => y(d[1]))
          .attr('width', x.bandwidth())
          .attr('height', d => height - y(d[1]))
          .attr('fill', d => {
            if (this.valuecalculation === 'average') {
              const t = this.getThresholdColor(d[1]);
              if (t) return t;
            }
            if (this.colorkey && this.colorkey !== '') {
              const item = filteredData.find(item => item[this.selectedxaxis] === d[0]);
              return item ? (item[this.colorkey] || '#62B2FD') : '#62B2FD';
            }
            return this.color(d[0]);
          })
          .attr("stroke", "none")
          .attr("style", d =>
            this.selectedGroups.length !== 0 ? (this.selectedGroups.includes(d[0]) ? "" : "opacity: 35%;") : ""
          )
          .on('mouseover', (event, d) => {
            d3.select(this.tooltip)
              .style('opacity', 1)
              .html(`Category: ${d[0]}<br>Value: ${this.formatBarLabel(d[1])}`)
              .style("left", this.mouseX + "px")
              .style("top", this.mouseY + "px");
          })
          .on("mouseout", () => d3.select(this.tooltip).style("opacity", 0))
          .on('mousemove', () => {
            d3.select(this.tooltip).style("left", this.mouseX + "px").style("top", this.mouseY + "px");
          })
          .on('click', (event, d) => {
            if (this.drilldowneabled) {
              d3.select(this.tooltip).style("opacity", 0);
              const filteredDataClick = this.data.filter(item => {
                const v = item[this.selectedxaxis];
                return v !== null && v !== undefined && String(v).trim() !== '' && v === d[0];
              });
              this.clickbarinchart(filteredDataClick, d[0]);
            }
          });

        svg.selectAll('text.bar-label')
          .data(groupedData)
          .enter()
          .append('text')
          .attr('class', 'bar-label')
          .attr('text-anchor', 'middle')
          .text(d => this.formatBarLabel(d[1]))
          .each((d, i, nodes) => {
            const text = d3.select(nodes[i]);
            const barHeight = height - y(d[1]);
            const xPos = (x(d[0]) || 0) + x.bandwidth() / 2;
            if (this.barlabelvertical) {
              const yPos = y(d[1]) + barHeight / 2;
              text
                .attr('x', xPos)
                .attr('y', yPos)
                .attr('fill', 'black')
                .attr('background', 'white')
                .attr('transform', `rotate(-90,${xPos},${yPos})`);
            } else {
              text
                .attr('x', xPos)
                .attr('y', y(d[1]) - 5);
            }
          });
      }
    },

    clickbarinchart(filteredData, filteredkeyword) {
      if (this.selectedGroups.includes(filteredkeyword)) {
        this.selectedGroups = this.selectedGroups.filter((k) => k !== filteredkeyword);
        const result = this.sortdata.filter(item => !filteredData.includes(item));
        this.sortdata = result;
        const filterarraydeleted = this.filterarray.filter(item => `(${filteredkeyword})` !== item);
        this.filterarray = filterarraydeleted;
        this.filterkeyword = `${this.categoryfield}=${this.selectedCategory},${this.selectedxaxis}=${this.selectedGroups}`;
      } else {
        this.selectedGroups.push(filteredkeyword);
        this.filterarray.push(`(${filteredkeyword})`);
        this.filterkeyword = `${this.categoryfield}=${this.selectedCategory},${this.selectedxaxis}=(${this.selectedGroups})`;
        this.sortdata = this.sortdata.concat(filteredData);
      }
      this.createBarChart();
    },

    recreateChart() {
      const dataToEmit = {
        sortedData: this.sortdata,
        filterkeyword: this.filterkeyword
      };
      this.$emit("drilldowncurrentchart", dataToEmit);
    },
  },
};
</script>

<style scoped>
@import "../../custom_lib/AiCharts/charts.css";

.bar-chart-container { width: 100%; overflow-x: auto; position: relative; }
.selectedbargraph{ opacity: 50%; }
svg { font-size: 10px; }
text.bar-label { fill: black; font-size: 12px; }

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}
.legandbox {
  width: 15px;
  height: 15px;
  margin-right: 3px;
}
.overflow-x-auto{ overflow-x:auto; }
.overflow-x-scroll{ overflow-x: auto; }
.legend-row {
  display: flex;
  justify-content: center;   /* ⬅️ center horizontally */
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  text-align: center;         /* nice fallback */
  margin: 4px 0;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #333;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 6px;
  border: 1px solid rgba(0,0,0,0.15);
}
</style>
